/**
 * PartyTask model translations
 *
 * Translation keys follow the pattern: models.party_task.{category}.{key}
 * Categories: fields, tabs, blocks, badges, actions, filters, options
 */
export default {
  en: {
    singular: "Task",
    plural: "Tasks",

    tabs: {
      general: "General",
      identity: "Identity",
      schedule: "Schedule",
      template: "Template & Instructions",
      attachments: "Attachments",
      historique: "History",
    },

    blocks: {
      identity: "Identity",
      schedule: "Schedule",
      schedule_days: "Schedule Days",
      template: "Template",
      default_steps: "Default Steps",
      task_actions: "Task Actions",
      addInfos: "Instructions",
      attachments: "Attachments",
      historique: "Activity log",
    },

    fields: {
      title: "Title",
      description: "Description",
      is_active: "Active",
      sort_order: "Sort Order",
      frequency: "Frequency",
      estimated_duration_minutes: "Duration",
      days_labels: "Days",
      template_id: "Template",
      party_id: "Client",
      created_at: "Created At",
      updated_at: "Updated At",
      is_from_template: "From Template",
      default_steps: "Default Steps",
      template: {
        title: "Template",
      },
      party: {
        name: "Client name",
        code: "Code",
      },
      schedule_pattern: {
        days: "Days",
        week_interval: "Week Interval",
        month_interval: "Month Interval",
        start_date: "Start Date",
        end_date: "End Date",
      },
      app_data: {
        addInfos: "Instructions",
      },
    },

    badges: {
      weekly: "Weekly",
      biweekly: "Biweekly",
      triweekly: "Triweekly",
      monthly: "Monthly",
      bimonthly: "Bimonthly",
      quarterly: "Quarterly",
      custom: "Custom",
      true: "Yes",
      false: "No",
    },

    filters: {
      party_id: "Client",
      is_active: "Status",
      frequency: "Frequency",
      template_id: "Template",
    },

    options: {
      frequency: {
        weekly: "Every Week",
        biweekly: "Every Two Weeks",
        triweekly: "Every Three Weeks",
        monthly: "Monthly",
        bimonthly: "Every Two Months",
        quarterly: "Every Three Months",
        custom: "Custom",
      },
      schedule_pattern: {
        days: {
          1: "Mon",
          2: "Tue",
          3: "Wed",
          4: "Thu",
          5: "Fri",
          6: "Sat",
          0: "Sun",
        },
      },
    },
  },

  fr: {
    singular: "Tâche",
    plural: "Tâches",

    tabs: {
      general: "Général",
      identity: "Identité",
      schedule: "Horaire",
      template: "Modèle & Instructions",
      attachments: "Pièces jointes",
      historique: "Historique",
    },

    blocks: {
      identity: "Identité",
      schedule: "Horaire",
      schedule_days: "Jours d'horaire",
      template: "Modèle",
      default_steps: "Étapes par défaut",
      task_actions: "Actions de tâche",
      addInfos: "Instructions",
      attachments: "Pièces jointes",
      historique: "Journal d'activité",
    },

    fields: {
      title: "Titre",
      description: "Description",
      is_active: "Actif",
      sort_order: "Ordre",
      frequency: "Fréquence",
      estimated_duration_minutes: "Durée",
      days_labels: "Jours",
      template_id: "Modèle",
      party_id: "Client",
      created_at: "Créé le",
      updated_at: "Modifié le",
      is_from_template: "Depuis un modèle",
      default_steps: "Étapes par défaut",
      template: {
        title: "Modèle",
      },
      party: {
        name: "Nom du client",
        code: "Code",
      },
      schedule_pattern: {
        days: "Jours",
        week_interval: "Intervalle de semaines",
        month_interval: "Intervalle de mois",
        start_date: "Date de début",
        end_date: "Date de fin",
      },
      app_data: {
        addInfos: "Instructions",
      },
    },

    badges: {
      weekly: "Hebdomadaire",
      biweekly: "Aux 2 semaines",
      triweekly: "Aux 3 semaines",
      monthly: "Mensuel",
      bimonthly: "Aux 2 mois",
      quarterly: "Aux 3 mois",
      custom: "Personnalisé",
      true: "Oui",
      false: "Non",
    },

    filters: {
      party_id: "Client",
      is_active: "Statut",
      frequency: "Fréquence",
      template_id: "Modèle",
    },

    options: {
      frequency: {
        weekly: "Toutes les semaines",
        biweekly: "Aux deux semaines",
        triweekly: "Aux trois semaines",
        monthly: "Mensuel",
        bimonthly: "Aux deux mois",
        quarterly: "Aux trois mois",
        custom: "Personnalisé",
      },
      schedule_pattern: {
        days: {
          1: "Lun",
          2: "Mar",
          3: "Mer",
          4: "Jeu",
          5: "Ven",
          6: "Sam",
          0: "Dim",
        },
      },
    },
  },
};
